import { userDataRequest } from '../../lib/userDataRequest';

export const getSharesStatus = () => {
  return userDataRequest('get', '/shares/status');
};

export const getShareToken = (grantableType, grantableId) => {
  return userDataRequest('post', `/shares/${grantableType}/${grantableId}`);
};

export const acceptShare = (grantableType, shareToken) => {
  return userDataRequest('patch', `/shares/accept/${grantableType}?token=${shareToken}`);
};

export const declineShare = (grantableType, shareToken) => {
  return userDataRequest('patch', `/shares/decline/${grantableType}?token=${shareToken}`);
};

export const destroyShare = (grantableType, grantableId, grantIndex) => {
  return userDataRequest('delete', `/shares/destroy/${grantableType}/${grantableId}`);
};

export const rescindShare = (grantableType, grantableId, grantIndex) => {
  return userDataRequest('patch', `/shares/${grantableType}/${grantableId}/${grantIndex}`);
};

export const leaveShare = (grantableType, grantableId) => {
  return userDataRequest('patch', `/shares/leave/${grantableType}/${grantableId}`);
};